// Lib
import React from 'react';
import { Modal as MuiModal, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Fade from '@mui/material/Fade';

// Components
import ModalHeader from './ModalHeader';

// Hooks
import useModalViewportHeight from './useModalViewportHeight';

// Utils
import { getModalDimensions } from './getModalDimensions';

// Styles
import { useStyles } from './ModalStyles';

const Modal = ({
  children,
  open,
  onClose,
  onClosed,
  closeIcon,
  styles,
  className,
  modalProps,
  ...props
}) => {
  const theme = useTheme();
  const { padding, right, top, transitionTimeout } = getModalDimensions(
    modalProps,
    theme,
  );
  const { classes, cx } = useStyles({
    styles,
    isFullScreen: modalProps?.isFullScreen,
    padding,
    right,
    top,
  });

  useModalViewportHeight();

  return (
    <MuiModal
      onClick={(e) => e.stopPropagation()}
      open={open}
      onClose={onClose}
      aria-labelledby="keep-mounted-modal-title"
      aria-describedby="keep-mounted-modal-description"
      BackdropProps={{
        classes: { root: classes.backdrop },
        timeout: transitionTimeout,
      }}
      closeAfterTransition
      {...props}>
      <Fade in={open} onExited={onClosed} timeout={transitionTimeout}>
        <Box
          id="modal-root"
          className={cx(
            classes.root,
            className,
            modalProps?.addressSavedCard && classes.addressSavedCard,
          )}>
          <div className={classes.contentContainer}>
            <div className={classes.content} id="content">
              <ModalHeader
                modalProps={modalProps}
                closeIcon={closeIcon}
                onClose={onClose}
                classes={classes}
              />
              {children}
            </div>
          </div>
        </Box>
      </Fade>
    </MuiModal>
  );
};

export default Modal;
